import React from "react";

import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";
import { vbabySystem } from "./theme";
import {
  Watch,
  ShareExam,
  Login,
  RequestPermissions,
  PaymentOpened,
  RecoveryAccess,
  EmbedPlayer,
  SecureAccess,
  NotFound,
  LoadingPage,
  LivePage,
  CheckoutWrapper,
  FinishPurchase,
} from "./pages";
import WatchDemo from "./pages/demo";
import Medstreamer from "./pages/medstreamer";
import DownloadApp from "./pages/download-app";
import { PriceScreen } from "./pages/checkout/PriceScreen";
import { PixScreen } from "./pages/checkout/PixScreen";
import { MethodScreen } from "./pages/checkout/MethodScreen";

const checkoutRoutes = (
  <>
    <Route index element={<PriceScreen />} />
    <Route path="pix" element={<PixScreen />} />
    <Route path="card" element={<MethodScreen method="card" />} />
    <Route path="boleto" element={<MethodScreen method="boleto" />} />
  </>
);

const Routers = () => {
  const useHash = window.location.hash.includes("#/");
  const isVbabyApp = window.location.hostname.includes("vbaby.app");
  const isException = window.location.hostname.match(
    "assista.urpinheiros.com.br"
  );
  // Fallback para links de secure-access sem hash, que o exams-api gerava antes
  // do b6cd2e89: sem isso o HashRouter resolve para "/" e o paciente cai no Login
  // em vez da tela de expirado. Rota exata, com ou sem barra final -- os dois
  // routers declaram "/secure-access" sem "/*", então subpath não renderiza
  // SecureAccess de qualquer forma.
  const isSecureAccessPath = /^\/secure-access\/?$/.test(
    window.location.pathname
  );
  // IMPORTANTE, ISSO NÃO DEVE SER TIRADO!! Eu sei que isso é feio, mas precisa ser rápido só para esse cliente, por enquanto :c
  if ((useHash || !isVbabyApp) && !isException && !isSecureAccessPath) {
    return (
      <HashRouter>
        <Routes>
          <Route
            path="/share-exam/:exam/:hash/:intern?"
            element={<ShareExam />}
          />
          <Route path="/embed-player/:exam/:hash" element={<EmbedPlayer />} />
          <Route path="/secure-access" element={<SecureAccess />} />
          <Route path="/loading/:id?" Component={LoadingPage} />
          <Route path="/watch" Component={Watch} />
          <Route path="/:id?/:paymentToken?" Component={Login} />
          <Route path="/forgotten" Component={RecoveryAccess} />
          <Route path="/request-permissions" Component={RequestPermissions} />
          <Route path="/PaymentOpened" Component={PaymentOpened} />
          <Route path="/watch-demo" Component={WatchDemo} />
          <Route path="/medstreamer" Component={Medstreamer} />
          <Route path="/checkout" Component={CheckoutWrapper}>
            {checkoutRoutes}
          </Route>
          <Route path="/finish-purchase" Component={FinishPurchase} />
          <Route path="/download-app" Component={DownloadApp} />

          <Route path="*" Component={NotFound} />
        </Routes>
      </HashRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/secure-access" element={<SecureAccess />} />
        <Route path="/:id?/:paymentToken?" Component={Login} />
        <Route path="/loading/:id?" Component={LoadingPage} />
        <Route path="/live" Component={LivePage} />
        <Route path="/live/:examParam?/:hashParam?" Component={LivePage} />
        <Route path="/forgotten" Component={RecoveryAccess} />
        <Route path="/watch" Component={Watch} />
        <Route path="/request-permissions" Component={RequestPermissions} />
        <Route path="/PaymentOpened" Component={PaymentOpened} />
        <Route path="/watch-demo" Component={WatchDemo} />
        <Route path="/checkout" Component={CheckoutWrapper}>
          {checkoutRoutes}
        </Route>
        <Route path="/finish-purchase" Component={FinishPurchase} />
        <Route path="/download-app" Component={DownloadApp} />
        
        <Route path="*" Component={NotFound} />
      </Routes>
    </BrowserRouter>
  );
};

const AppRoutes = () => (
  <ChakraProvider value={vbabySystem}>
    <Routers />
  </ChakraProvider>
);

export default AppRoutes;
